export default __webpack_public_path__ + "static/media/bootstrap.d5210cde.png";